module.exports = __webpack_public_path__ + "img/home_top.12353af9.jpg";